import React, { useState } from 'react';
import api from '../services/api';
import './InquirySection.css';

function InquirySection({ headline, reassurance }) {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    subject: '',
    comment: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      await api.post('/inquiries', {
        inquiry: formData
      });
      setSubmitted(true);
      setFormData({
        full_name: '',
        email: '',
        subject: '',
        comment: ''
      });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      setError('Failed to submit inquiry. Please try again.');
    }
  };

  return (
    <section id="inquiry" className="inquiry-section animate-on-scroll">
      <div className="container">
        <h2 className="section-title">
          {headline || 'Inquiry'}
        </h2>
        {reassurance && (
          <p className="inquiry-reassurance">{reassurance}</p>
        )}
        <form onSubmit={handleSubmit} className="inquiry-form">
          <div className="form-group">
            <label htmlFor="full_name">Full Name</label>
            <input
              type="text"
              id="full_name"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="comment">Comment</label>
            <textarea
              id="comment"
              name="comment"
              value={formData.comment}
              onChange={handleChange}
              rows="5"
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {submitted && <div className="success-message">Thank you! Your inquiry has been submitted.</div>}
          <div className="form-actions">
            <button type="submit" className="btn-submit">Submit Now</button>
            <button type="button" className="btn-cancel" onClick={() => setFormData({
              full_name: '',
              email: '',
              subject: '',
              comment: ''
            })}>Cancel</button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default InquirySection;
